/*
 * Known Issue: the `metadata` is irgnored because it triggers a CORS issue.
 * The root cause is unclear at this time, and resolving this is not a high priority task.
 *
 * However, the metadata is retained in the code for potential future use, once the CORS issue is addressed.
 */
export async function uploadFileToBlobStorage(
    file: File,
    sasUrl: string,
    { onProgress }: { onProgress?: (progress: { file: File; loadedBytes: number; totalBytes: number }) => void } = {},
): Promise<void> {
    const { ContainerClient } = await import('@azure/storage-blob');

    const blobName = sanitizeFileName(file.name);

    const containerClient = new ContainerClient(sasUrl);
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);

    await blockBlobClient.uploadData(file, {
        onProgress: (progress) => {
            onProgress?.({ file, loadedBytes: progress.loadedBytes, totalBytes: file.size });
        },
    });
}

export function sanitizeFileName(filename: string): string {
    return filename.replace(/[^a-zA-Z0-9_.-]/g, '_');
}
